import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Proceed = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/login', {
      replace: true,
      state: {
        loginMessage:
          'Self-signup is no longer available. Contact your HR admin to provision your account, then sign in.',
      },
    });
  }, [navigate]);

  return null;
};

export default Proceed;
